"use client";

import { c as _c } from "react/compiler-runtime";
import { Partner } from "@justhome/api-core";
import clsx from "clsx";
import { Control, Controller, FieldValues, Path } from "react-hook-form";
import Checkbox from "../Checkbox";
import { Locale, render } from "../lib/i18n";
const translations = {
  de: {
    form_consent_terms: "Ich möchte den für mich kostenlosen Service von Justhome rund um Immobilienfinanzierung, -suche und -information nutzen. Es gelten die <a class='text-primary-800' href='https://justhome.com/datenschutz' target='_blank'>Datenschutzbestimmungen</a> und <a href='https://justhome.com/agb' target='_blank' class='text-primary-800'>AGB</a> der Justhome GmbH.",
    form_consent_terms_partner: "Ich möchte den für mich kostenlosen Service von Justhome rund um Immobilienfinanzierung, -suche und -information nutzen. Justhome hält für einen reibungslosen Ablauf meinen Immobilienmakler informiert. Mit der Übermittlung meiner Daten an die Justhome GmbH bin ich einverstanden. Es gelten die <a class='text-primary-800' href='https://justhome.com/datenschutz' target='_blank'>Datenschutzbestimmungen</a> und <a href='/agb' target='_blank' class='text-primary-800'>AGB</a> der Justhome GmbH.",
    form_consent_terms_partner_seller_leads: "Ich möchte den für mich kostenlosen Service von Justhome rund um Immobilienfinanzierung, -suche und -information nutzen. Justhome hält für einen reibungslosen Ablauf meinen Immobilienmakler informiert, u.a. zu Leistbarkeit, Kaufbudget und Verkaufsabsicht. Mit der Übermittlung meiner Daten an die Justhome GmbH bin ich einverstanden. Es gelten die <a class='text-primary-800' href='https://justhome.com/datenschutz' target='_blank'>Datenschutzbestimmungen</a> und <a href='https://justhome.com/agb' target='_blank' class='text-primary-800'>AGB</a> der Justhome GmbH.",
    form_consent_terms_partner_external_advisor: "Ich möchte den für mich kostenlosen Service von Justhome und seinen <a class='text-primary-800' href='https://justhome.com/finanzierungspartner' target='_blank'>Finanzierungspartnern</a> rund um die Immobilienfinanzierung, -suche und -information nutzen. Ich bin damit einverstanden, dass mein Makler für einen reibungslosen Ablauf informiert bleibt und dass meine Daten an die Justhome GmbH &amp; ihre Finanzierungspartner übermittelt werden. Es gelten die <a class='text-primary-800' href='https://justhome.com/datenschutz' target='_blank'>Datenschutzrichtlinien</a> und <a href='https://justhome.com/agb' target='_blank' class='text-primary-800'>AGBs</a> der Justhome GmbH.",
    form_consent_terms_partner_external_advisor_seller_leads: "Ich möchte den für mich kostenlosen Service von Justhome und seinen <a class='text-primary-800' href='https://justhome.com/finanzierungspartner' target='_blank'>Finanzierungspartnern</a> rund um die Immobilienfinanzierung, -suche und -information nutzen. Ich bin damit einverstanden, dass mein Makler für einen reibungslosen Ablauf informiert bleibt, u.a. zu Leistbarkeit, Kaufbudget und Verkaufsabsicht, und dass meine Daten an die Justhome GmbH &amp; ihre Finanzierungspartner übermittelt werden. Es gelten die <a class='text-primary-800' href='https://justhome.com/datenschutz' target='_blank'>Datenschutzrichtlinien</a> und <a href='https://justhome.com/agb' target='_blank' class='text-primary-800'>AGBs</a> der Justhome GmbH.",
    partner_contact_sharing_opt_in: "Ich bin damit einverstanden, dass meine Kontaktdaten an {partner} zum Zwecke der Kontaktaufnahme weitergeleitet werden.",
    partner_budget_sharing_opt_in: "Ich bin damit einverstanden, dass meine Kontaktdaten und mein maximales Kaufbudget an {partner} zum Zwecke der Kontaktaufnahme weitergeleitet werden.",
    opt_in_error: "Um den Service nutzen zu können, benötigen wir die Zustimmung zu den Nutzungsbedingungen und der Datenweitergabe."
  },
  en: {
    form_consent_terms: "I would like to use Justhome’s service, which is free of charge for me, regarding real estate financing, search, and information. The <a class='text-primary-800' href='https://justhome.com/en/data-privacy' target='_blank'>privacy policy</a> and <a href='https://justhome.com/en/terms-and-conditions' target='_blank' class='text-primary-800'>terms and conditions</a> of Justhome GmbH apply.",
    form_consent_terms_partner: "I would like to use Justhome’s service, which is free of charge for me, regarding real estate financing, search, and information. Justhome keeps my real estate agent informed to ensure a smooth process. I agree to the transmission of my data to Justhome GmbH. The <a class='text-primary-800' href='https://justhome.com/en/data-privacy' target='_blank'>privacy policy</a> and <a href='https://justhome.com/en/terms-and-conditions' target='_blank' class='text-primary-800'>terms and conditions</a> of Justhome GmbH apply.",
    form_consent_terms_partner_seller_leads: "I would like to use Justhome’s service, which is free of charge for me, regarding real estate financing, search, and information. Justhome keeps my real estate agent informed to ensure a smooth process, including about affordability, purchase budget, and intent to sell. I agree to the transmission of my data to Justhome GmbH. The <a class='text-primary-800' href='https://justhome.com/en/data-privacy' target='_blank'>privacy policy</a> and <a href='https://justhome.com/en/terms-and-conditions' target='_blank' class='text-primary-800'>terms and conditions</a> of Justhome GmbH apply.",
    form_consent_terms_partner_external_advisor: "I would like to use the service of Justhome and its <a class='text-primary-800' href='https://justhome.com/en/financingpartner' target='_blank'>financing partners</a>, which is free of charge for me, regarding real estate financing, search, and information. I agree that my agent remains informed to ensure a smooth process and that my data will be transmitted to Justhome GmbH and its financing partners. The <a class='text-primary-800' href='https://justhome.com/en/data-privacy' target='_blank'>privacy policy</a> and <a href='https://justhome.com/en/terms-and-conditions' target='_blank' class='text-primary-800'>terms and conditions</a> of Justhome GmbH apply.",
    form_consent_terms_partner_external_advisor_seller_leads: "I would like to use the service of Justhome and its <a class='text-primary-800' href='https://justhome.com/en/financingpartner' target='_blank'>financing partners</a>, which is free of charge for me, regarding real estate financing, search, and information. I agree that my agent remains informed to ensure a smooth process, including about affordability, purchase budget, and intent to sell, and that my data will be transmitted to Justhome GmbH and its financing partners. The <a class='text-primary-800' href='https://justhome.com/en/data-privacy' target='_blank'>privacy policy</a> and <a href='https://justhome.com/en/terms-and-conditions' target='_blank' class='text-primary-800'>terms and conditions</a> of Justhome GmbH apply.",
    partner_contact_sharing_opt_in: "I agree that my contact details will be forwarded to {partner} for the purpose of making contact.",
    partner_budget_sharing_opt_in: "I agree that my contact details and my maximum purchase budget will be forwarded to {partner} for the purpose of making contact.",
    opt_in_error: "To use the service, we need your consent to the terms of use and data transfer."
  }
};
export const getFormConsentText = ({
  locale,
  requireContactSharingOptIn = false,
  requireBudgetSharingOptIn = false,
  partner
}: {
  locale: Locale;
  requireContactSharingOptIn?: boolean;
  requireBudgetSharingOptIn?: boolean;
  partner?: Partner;
}): string => {
  const t = translations[locale];
  const consentText = t[getFormConsentKey(!!partner, partner?.isExternalAdvisorEnabled, partner?.hasSellerLeadsEnabled)];
  const optInKey = getOptInKey(requireBudgetSharingOptIn, requireContactSharingOptIn);
  let optInText = "";
  if (optInKey) {
    optInText = render(t[optInKey], {
      partner: partner?.name ?? "Justhome GmbH"
    });
  }
  return [consentText, optInText].filter(Boolean).join(" ");
};
const getFormConsentKey = (isPartner = false, isExternalAdvisorEnabled = false, hasSellerLeadsEnabled = false): keyof typeof translations.de => {
  if (!isPartner) {
    return "form_consent_terms";
  }
  if (isExternalAdvisorEnabled) {
    return hasSellerLeadsEnabled ? "form_consent_terms_partner_external_advisor_seller_leads" : "form_consent_terms_partner_external_advisor";
  }
  return hasSellerLeadsEnabled ? "form_consent_terms_partner_seller_leads" : "form_consent_terms_partner";
};
const getOptInKey = (requireBudgetSharingOptIn: boolean, requireContactSharingOptIn: boolean): keyof typeof translations.de | null => {
  if (requireBudgetSharingOptIn) {
    return "partner_budget_sharing_opt_in";
  }
  if (requireContactSharingOptIn) {
    return "partner_contact_sharing_opt_in";
  }
  return null;
};
export interface FormLegalDisclaimerProps<TFieldValues extends FieldValues> {
  locale: Locale;
  partner?: Partner;
  requireBudgetSharingOptIn?: boolean;
  control?: Control<TFieldValues, any>;
  optInFieldName?: Path<TFieldValues>;
  requireContactSharingOptIn?: boolean;
  className?: string;
  disclaimerClassName?: string;
}
const FormLegalDisclaimer = t0 => {
  const $ = _c(30);
  const {
    locale,
    partner,
    requireBudgetSharingOptIn: t1,
    control,
    optInFieldName,
    requireContactSharingOptIn: t2,
    className,
    disclaimerClassName
  } = t0;
  const requireBudgetSharingOptIn = t1 === undefined ? false : t1;
  const requireContactSharingOptIn = t2 === undefined ? false : t2;
  const t = translations[locale];
  const disclaimerKey = getFormConsentKey(!!partner, partner?.isExternalAdvisorEnabled, partner?.hasSellerLeadsEnabled);
  const disclaimerText = t[disclaimerKey];
  const optInKey = getOptInKey(requireBudgetSharingOptIn, requireContactSharingOptIn);
  if (optInKey && control) {
    const t3 = t[optInKey];
    const t4 = partner?.name ?? "Justhome GmbH";
    let t5;
    if ($[0] !== t3 || $[1] !== t4) {
      t5 = render(t3, {
        partner: t4
      });
      $[0] = t3;
      $[1] = t4;
      $[2] = t5;
    } else {
      t5 = $[2];
    }
    const optInText = t5;
    let t6;
    if ($[3] !== disclaimerClassName) {
      t6 = clsx("mb-3s text-app-body-2", disclaimerClassName);
      $[3] = disclaimerClassName;
      $[4] = t6;
    } else {
      t6 = $[4];
    }
    let t7;
    if ($[5] !== disclaimerText) {
      t7 = {
        __html: disclaimerText
      };
      $[5] = disclaimerText;
      $[6] = t7;
    } else {
      t7 = $[6];
    }
    let t8;
    if ($[7] !== t6 || $[8] !== t7) {
      t8 = <p className={t6} dangerouslySetInnerHTML={t7} />;
      $[7] = t6;
      $[8] = t7;
      $[9] = t8;
    } else {
      t8 = $[9];
    }
    const t9 = optInFieldName as Path<TFieldValues>;
    let t10;
    if ($[10] !== t.opt_in_error) {
      t10 = {
        required: t.opt_in_error
      };
      $[10] = t.opt_in_error;
      $[11] = t10;
    } else {
      t10 = $[11];
    }
    let t11;
    if ($[12] !== optInText) {
      t11 = t12 => {
        const {
          field,
          fieldState
        } = t12;
        return <Checkbox size="sm" className="mb-3s" checked={field.value} onChange={field.onChange} onBlur={field.onBlur} name={field.name} errorMessage={fieldState.error?.message}>{optInText}</Checkbox>;
      };
      $[12] = optInText;
      $[13] = t11;
    } else {
      t11 = $[13];
    }
    let t12;
    if ($[14] !== control || $[15] !== t10 || $[16] !== t11 || $[17] !== t9) {
      t12 = <Controller control={control} name={t9} rules={t10} render={t11} />;
      $[14] = control;
      $[15] = t10;
      $[16] = t11;
      $[17] = t9;
      $[18] = t12;
    } else {
      t12 = $[18];
    }
    let t13;
    if ($[19] !== className || $[20] !== t12 || $[21] !== t8) {
      t13 = <div className={className}>{t8}{t12}</div>;
      $[19] = className;
      $[20] = t12;
      $[21] = t8;
      $[22] = t13;
    } else {
      t13 = $[22];
    }
    return t13;
  }
  let t3;
  if ($[23] !== className) {
    t3 = clsx("mt-2xs text-app-body-2", className);
    $[23] = className;
    $[24] = t3;
  } else {
    t3 = $[24];
  }
  let t4;
  if ($[25] !== disclaimerText) {
    t4 = {
      __html: disclaimerText
    };
    $[25] = disclaimerText;
    $[26] = t4;
  } else {
    t4 = $[26];
  }
  let t5;
  if ($[27] !== t3 || $[28] !== t4) {
    t5 = <div className={t3} dangerouslySetInnerHTML={t4} />;
    $[27] = t3;
    $[28] = t4;
    $[29] = t5;
  } else {
    t5 = $[29];
  }
  return t5;
};
export default FormLegalDisclaimer;